// components/ServiceSection.tsx
import React from "react";
import { FormattedMessage } from "react-intl";
import { Skeleton } from "antd-mobile";
import {
  IThirdPartyService,
  SERVICE_TYPE,
  PLATFORM_CONFIGS,
  ServicePlatformType,
} from "request";
interface ServiceSectionProps {
  serviceType: string;
  services: IThirdPartyService[];
  isLoading: boolean;
  onToCommandPage: (service: IThirdPartyService) => void;
  publicPath?: string;
  isAndroid: boolean;
}

export const filterServices = (
  services: IThirdPartyService[],
  serviceType: string,
  isAndroid: boolean
): IThirdPartyService[] => {
  return services
    .filter((service) => service.soundType === serviceType)
    .filter(
      (service) =>
        PLATFORM_CONFIGS[service.showFlag as ServicePlatformType].enabled
    )
    .filter((service) =>
      isAndroid
        ? PLATFORM_CONFIGS[
            service.showFlag as ServicePlatformType
          ].supportedPlatforms.includes("android")
        : PLATFORM_CONFIGS[
            service.showFlag as ServicePlatformType
          ].supportedPlatforms.includes("ios")
    );
};

export const SkeletonItem = () => {
  const logoStyle = {
    "--width": "54px",
    "--height": "54px",
    "--border-radius": "8px",
  };

  const titleStyle = {
    "--width": "50%",
    "--height": "16px",
    "--border-radius": "2px",
  };

  return (
    <div className="flex flex-col items-center gap-3">
      <Skeleton animated style={logoStyle} />
      <Skeleton animated style={titleStyle} />
    </div>
  );
};

export const ServiceSection: React.FC<ServiceSectionProps> = ({
  serviceType,
  services,
  isLoading,
  onToCommandPage,
  isAndroid,
}) => {
  const filteredServices = filterServices(services, serviceType, isAndroid);

  if (filteredServices.length === 0 && !isLoading) {
    return null;
  }

  return (
    <div className="mt-4 bg-white dark:bg-gray323434 rounded px-3 py-4">
      <p className="text-xs">
        {serviceType === SERVICE_TYPE.voice && (
          <FormattedMessage id="thirdParty.service.voice.title" />
        )}
        {serviceType === SERVICE_TYPE.health && (
          <FormattedMessage id="thirdParty.service.health.title" />
        )}
      </p>
      <div className="grid grid-cols-2 gap-10 mt-7 pb-2">
        {isLoading ? (
          <SkeletonItem />
        ) : (
          <>
            {filteredServices.map((service, key) => (
              <div
                className="flex flex-col items-center gap-3"
                key={key}
                onClick={() => onToCommandPage(service)}
              >
                <img
                  src={service.image}
                  className="w-[54px] h-[54px]"
                  alt={service.name}
                />
                <span>{service.name}</span>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};
